import { useMutation } from '@tanstack/react-query';
import { submitPromoEnquiry } from '../api/promoApi';

export function usePromoEnquiryMutation(defaultAlias = '') {
  return useMutation({
    mutationFn: (payload) => submitPromoEnquiry({ alias: payload?.alias ?? defaultAlias, payload }),
  });
}
